<template >
   
</template>
<script>
import cookie from 'vue-cookie'
export default {
    beforeMount() {
        cookie.delete('token');
        this.$store.commit('setClear')
        this.$router.push({name:'Login'})        
    },
}
</script>
<style lang="">
    
</style>